export const moneyFormatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

export const formatMoney = (value: Maybe<number>) =>
    moneyFormatter.format(value ?? 0);
